import { Component } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';

import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';

import { selectJob } from 'src/app/job/job-tool.reducer';
import { ControlFieldStatus, selectCustomerStepControlStatus, selectLocationStepControlStatus } from 'src/app/new-opportunity/step-navigation/step-navigation.component';

import { NewOpportunityActions } from '../new-opportunity.actions';
import { newOpportunityFeature } from '../new-opportunity.feature';
import { NEW_OPPORTUNITY_STEPS, NEW_OPPORTUNITY_STEP_TITLES } from '../new-opportunity.state';

const selectSteps = createSelector(
    newOpportunityFeature.selectStep,
    selectCustomerStepControlStatus,
    selectLocationStepControlStatus,
    selectJob,
    (currentStep, customerStatus, locationStatus, job) => {

        const hasJob = Boolean(job);
        const currentIndex = NEW_OPPORTUNITY_STEPS.indexOf(currentStep);

        // Requirement `#6401` - For a loaded job, surface errors regardless of touched state so the agent
        // gets a live checklist of what is still incomplete across every step (the
        // touched meta only exists for the currently-mounted step). In the create
        // flow we keep the touched gate so a blank form does not show errors before
        // the user has interacted with the fields.
        const isVisible = (f: ControlFieldStatus) => f.error !== null && (hasJob || f.touched);

        let disabled = false;

        return NEW_OPPORTUNITY_STEPS.map((step, index) => {

            let errorMessage = null;

            if (step === 'customer') {
                errorMessage = Object.values(customerStatus).find(isVisible)?.error;
            }

            if (step === 'locations') {
                errorMessage = Object.values(locationStatus).find(isVisible)?.error;
            }

            const processed = {
                key: step,
                title: NEW_OPPORTUNITY_STEP_TITLES[step],
                current: index === currentIndex,
                past: index < currentIndex,
                errorMessage,
                disabled,
            };

            // If a step has any errors, any subsequent steps must be disabled — but
            // only in the create flow. A loaded job allows free navigation.
            if (!hasJob && step === 'customer' && Object.values(customerStatus).some((f) => Boolean(f.error))) {
              disabled = true;
            }

            if (!hasJob && step === 'locations' && Object.values(locationStatus).some((f) => Boolean(f.error))) {
              disabled = true;
            }

            return processed;
        });
    }
);

@Component({
    selector: 'app-stepper',
    standalone: true,
    imports: [
        FreyaCommonModule,
    ],
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {

    public actions = NewOpportunityActions;

    viewModel$ = this.store.select(createSelector({
        steps: selectSteps,
        currentStep: newOpportunityFeature.selectStep,
    }));

    constructor(
        public store: Store,
    ) {}
}
